import React, { useEffect, useState } from 'react';
import {
  Dialog,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
  Select,
  Option,
  Input,
} from '@material-tailwind/react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { Controller, useForm } from 'react-hook-form';
import InputGlobal from '../InputGlobal';
import ButtonGlobal from '../ButtonGlobal';
import MsgSucess from '../MsgSucess';
import { useFuncAtualizarDados } from '../../hook/useFuncPatch';

import { useErroControlManul } from '../../hook/useErroControlManul';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../slices/authSlice';

export function ModalPassword({ id: usuario, handleModal }) {
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    setError,
    control,
    formState: { errors },
  } = useForm();
  const { result, pathsCall, resetInfo: resetCadastro } = useFuncAtualizarDados();
  const { useArrayErrorForm } = useErroControlManul();
  const [status, setStatus] = useState(usuario.is_active ? '0' : '1');
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    const { password, repeat_password, is_active } = data;
    if (password && repeat_password) {
      const data = { password, repeat_password };
      return pathsCall(usuario.id, data);
    }

    pathsCall(usuario.id, { is_active: is_active === '0' ? true : false });
  };

  useEffect(() => {
    return () => clearErrors();
  }, []);

  useEffect(() => {
    if (result?.error) {
      useArrayErrorForm(result?.error, setError);
    }
  }, [result]);

  const resetInfo = () => {
    reset();
    resetCadastro();
    handleModal();
    dispatch(getUsers());
  };

  return (
    <>
      <Dialog
        size="sm"
        open={!!usuario}
        handler={resetInfo}
        className={`p-4 bg-lightMenu dark:bg-none dark:bg-darkColorBg`}
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h4" className="text-black dark:text-darkText">
            Editar
          </Typography>
          <IconButton
            size="sm"
            variant="text"
            className="!absolute right-3.5 top-3.5"
            onClick={resetInfo}
          >
            <XMarkIcon className="h-4 w-4 stroke-2 dark:text-darkText" />
          </IconButton>
        </DialogHeader>
        <DialogBody className="space-y-4 pb-6">
          <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-2">
              <Typography
                variant="h6"
                className="mb-1 text-left font-medium  capitalize text-black dark:!text-darkText"
              >
                Nome
              </Typography>
              <Input
                type="text"
                size="lg"
                variant="outlined"
                className={`${' placeholder:text-gray-500  text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 bg-white '} placeholder:opacity-100   bg-white dark:bg-darkBgInput uppercase disabled:bg-gray-600 }`}
                labelProps={{
                  className: 'hidden ',
                }}
                value={usuario?.usuario || ''}
                containerProps={{
                  className: 'min-w-full',
                }}
                disabled
              />
            </div>
            <div>
              <InputGlobal
                formCamp="password"
                type="password"
                label="Senha "
                placeholder="Digite sua senha"
                register={register}
                errors={errors?.password ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
            <div>
              <InputGlobal
                formCamp="repeat_password"
                type="password"
                label="Repetir senha "
                placeholder="Digite novamente a senha"
                register={register}
                errors={errors?.repeat_password ? errors : false}
                css="w-full"
                error={result?.error}
              />
            </div>
            {usuario && (
              <div>
                <Typography
                  variant="h6"
                  className="mb-1 text-left font-medium  capitalize text-black dark:!text-darkText"
                >
                  Status
                </Typography>
                <Controller
                  name="is_active" // Nome do campo
                  control={control} // Controle do React Hook Form
                  defaultValue={usuario.is_active ? '0' : '1'} // Valor padrão
                  render={({ field }) => (
                    <Select
                      className={`${' placeholder:text-gray-500  text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 bg-white '} placeholder:opacity-100   bg-white dark:bg-darkBgInput uppercase `}
                      value={status}
                      onChange={(val) => setStatus(val)}
                      label=""
                      {...field} // Props do Hook Form (inclui onChange e value)
                      labelProps={{ className: 'hidden' }}
                    >
                      <Option value="0">Ativo</Option>
                      <Option value="1">Desativado</Option>
                    </Select>
                  )}
                />
              </div>
            )}
          </form>
        </DialogBody>
        <DialogFooter>
          <ButtonGlobal
            className="ml-auto"
            click={handleSubmit(onSubmit)}
            color="blue"
            text={'Salvar'}
          />
        </DialogFooter>
        {result?.sucess && <MsgSucess reset={resetInfo} outText="Salvo com sucesso" />}
      </Dialog>
    </>
  );
}
